import { Button, Flex } from '@radix-ui/themes';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportData } from 'src/@types/reports';
import Filter, { FTypes } from 'src/components/Filter';
import MainLayout from 'src/components/MainLayout';
import TablePaginated from 'src/components/TablePaginated';
import Reports from 'src/infraestructure/services/api/Reports';

// import { Container } from './styles';

const ReportByGame: React.FC = () => {

    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [list, setList] = useState<ReportData>();
    const [page, setPage] = useState<number>(1);
    const [filters, setFilteres] = useState<any>();

    const handleFilter = async (data: any) => {
        setLoading(true);
        const reportByBet = await Reports.getReport({
            clientId: data.PersonalId,
            type: "report-by-game",
            page: 1,
            limit: 25,
            startDate: data.startDate,
            endDate: data.endDate
        });

        if(reportByBet && reportByBet.data) {
            setFilteres({
                clientId: data.PersonalId,
                type: "report-by-game",
                limit: 25,
                startDate: data.startDate,
                endDate: data.endDate
            });

            setList(reportByBet.data);
        }

        setLoading(false);
    }
    
    const backPage = async () => {
        let curPage = page - 1;
        const reportByBet = await Reports.getReport({
            clientId: filters.clientId,
            type: "report-by-game",
            page: curPage,
            limit: 25,
            startDate: filters.startDate,
            endDate: filters.endDate
        });

        if(reportByBet && reportByBet.data.ReportByTResultViewModel) {
            setList(reportByBet.data);
            setPage(curPage);
        }
    }

    const nextPage = async () => {
        let curPage = page + 1;
        const reportByBet = await Reports.getReport({
            clientId: filters.clientId,
            type: "report-by-game",
            page: curPage,
            limit: 25,
            startDate: filters.startDate,
            endDate: filters.endDate
        });

        if(reportByBet && reportByBet.data.ReportByTResultViewModel) {
            setList(reportByBet.data);
            setPage(curPage);
        }
    }

    return (
        <MainLayout>
            <Filter
                filters={[
                    {
                        name: "search",
                        placeholder: t("Pesquisar por") as string,
                        type: FTypes.selectInput,
                        predefinedValue: "PersonalId",
                        options: [
                            {
                                label: "ID do Jogador",
                                value: "PersonalId",
                            }
                        ],
                    },
                    {
                        name: "startDate,endDate",
                        placeholder: t("Pesquisar por") as string,
                        type: FTypes.range,
                        predefinedValue: [startOfDay(new Date()), endOfDay(addDays(new Date(), +1))],
                        format: 'DD-MM-YY'
                    }
                ]}
                loading={loading}
                onPress={handleFilter}
            />

            <TablePaginated 
                data={list?.ReportByTResultViewModel} 
                totalItems={0} 
                keys={[
                    {
                        name: "Modified",
                        type: "date"
                    },
                    {
                        name: "PlayerId",
                        type: "number"
                    },
                    {
                        name: "GameId",
                        type: "number"
                    },
                    {
                        name: "GameName",
                        type: "string"
                    },
                    {
                        name: "ProviderName",
                        type: "string"
                    },
                    {
                        name: "BetAmount",
                        sum: true,
                        type: "money"
                    },
                    {
                        name: "WinAmount",
                        sum: true,
                        type: "money"
                    },
                    {
                        name: "GGR",
                        sum: true,
                        calculate: 'substract,BetAmount,WinAmount',
                        type: "number",
                        children: ((response) => {
                            return(
                                <div>
                                    R${response.BetAmount - response.WinAmount}
                                </div>
                            )
                        })
                    }
                ]} 
                perPage={0} 
                onPageChange={function (page: number): void {
                    throw new Error('Function not implemented.');
                } }                
            />
            {filters && <Flex width={"100%"} align={"center"} gap={"10px"} justify={"center"} mt={"10px"}>
                {page !== 1 && <Button variant='soft' onClick={() => {
                    backPage();
                }}>Anterior</Button>}
                <div>{page}</div>
                <Button variant='soft' onClick={() => {
                    nextPage();
                }}>Próximo</Button>
            </Flex>}
        </MainLayout>
    );
}

export default ReportByGame;